import { DownloadFileLogicalNameType } from '@/request-config/file-provider/file-provider.types';

export enum FileFormat {
  XLS = 'xls',
  XLSX = 'xlsx',
  JPG = 'jpg',
  JPEG = 'jpeg',
  PNG = 'png',
  PDF = 'pdf',
  TIFF = 'tiff'
}

export interface IFile {
  filePath: string;
  name: string;
  fileId: string;
  description: string;
  fileProviderId?: string;
}

export interface FileInfoProps {
  icon?: string;
  fileName: string;
  fileSize: number;
  lastModified: string;
  onClick?: () => void;
  onDelete?: () => void;
  file: IFile;
  allFiles?: IFile[];
  hideCheckBox?: boolean;
  hideModifyDate?: boolean;
  withoutFileViewer?: boolean;
  isDownloadButton?: boolean;
  id?: string;
  containerClassname?: string;
  logicalName?: DownloadFileLogicalNameType;
}

export interface FileIconProps {
  fileFormat: string;
}
